import { render, staticRenderFns } from "./JavaKaifa.vue?vue&type=template&id=af79d436&scoped=true&"
import script from "./JavaKaifa.vue?vue&type=script&lang=js&"
export * from "./JavaKaifa.vue?vue&type=script&lang=js&"
import style0 from "./JavaKaifa.vue?vue&type=style&index=0&id=af79d436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af79d436",
  null
  
)

export default component.exports